<template>
  <div class="events-area bg-shape bg-eee8df" id="etkinliklerimiz">
    <div class="container">
      <div class="row">

        <div class="col-lg-6 col-md-12 col-sm-6" v-for="activity of  activities " :key="activity.activity_id">
          <div class="events-box">
            <div class="row m-0">
              <div class="col-lg-4 col-md-5 p-0">
                <div class="image">
                  <img :src="getImgUrl('etkinlikler', activity.activity_img)" alt="{{ activity.activity_header }}"
                    style="display: flex; height: 100%; object-fit: cover;">
                </div>
              </div>
              <div class="col-lg-8 col-md-7 p-0">
                <div class="content">
                  <div class="date">
                    <img src="../../assets/img/shape/rectangle2.png" alt="image">
                    <span>{{ activity.activity_time }}</span>
                  </div>
                  <h3 class="font-weight-black">
                    <router-link :to="getUrl(activity.activity_id)">{{ activity.activity_header
                    }}</router-link>
                  </h3>
                  <p>{{ activity.activity_content }}</p>
                  <span class="location"><i class="bx bx-map"></i>{{ activity.activity_location }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="kindergarten-shape17">
      <img src="../../assets/img/kindergarten-shape/k-shape17.png" alt="image">
    </div>
    <div class="kindergarten-shape18">
      <img src="../../assets/img/kindergarten-shape/k-shape18.png" alt="image">
    </div>
  </div>
</template>

<script>

import axios from "axios";


export default {
  name: 'CoursesList',
  props: ['pathUrl'],

  created() {
    this.getTitles();
    this.getAllActivities();
  },
  data() {
    return {
      titles: [],
      activities: [],
      errors: []
    };
  },
  methods: {
    getTitles() {
      axios
        .get(this.pathUrl + "?data=title&parent=8")
        .then(response => (this.titles = response.data.result))
        .catch(error => {
          this.errors.push(error);
        });
    },
    getAllActivities() {
      axios
        .get(this.pathUrl + "?data=activities")
        .then(response => (this.activities = response.data.result))
        .catch(error => {
          this.errors.push(error);
        });
    },
    getImgUrl(category, pet) {
      return require('../../../../assets/resimler/' + category + '/' + pet)
    },
    getUrl(pet) {
      return 'etkinliklerimiz/' + pet
    }
  }
}
</script>